<template>
  <el-container>
    <el-header style="margin-top: 20px;">
      <span>Grabar Acta Valorización Infraestructura</span>
    </el-header>
    <el-main style="width: 100%; margin-top: 20px;">
      <el-form :model="form" ref="form-acta-valor-infra" label-width="120px" :rules="rules">
        <el-row :gutter="20">
          <!-- 🔹 Tarjeta de Valores a Ingresar -->
          <el-col :span="16">
            <el-card shadow="hover">
              <template #header>
                <span style="font-weight: bold;">Valores a Ingresar</span>
              </template>

              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="Fecha Corte" prop="acco_fechacorte">
                    <el-tooltip content="Fecha de Corte" placement="top">
                      <el-date-picker v-model="acco_fechacorte" type="month" placeholder="Selecciona un mes"
                        format="yyyy-MM" value-format="yyyy-MM" style="width: 100%;" />
                    </el-tooltip>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-tooltip content="IPP del mes, entregado por el DANE" placement="top">
                    <el-form-item label="IPPm" prop="acvi_ippm">
                      <el-input v-model="form.acvi_ippm" type="number" step="0.01" />
                    </el-form-item>
                  </el-tooltip>
                </el-col>
              </el-row>
            </el-card>
          </el-col>

          <!-- 🔹 Tarjeta de Valores Constantes -->
          <el-col :span="8">
            <el-card shadow="never" style="background-color: #f9f9f9;">
              <template #header>
                <span style="font-weight: bold;">Valores Constantes</span>
              </template>

              <el-form-item label="IPPo" prop="ippm_MesAnterior">
                <el-input v-model="ippm_MesAnterior" :disabled="true" />
              </el-form-item>

            </el-card>
          </el-col>
        </el-row>


        <el-row>
          <add-elements :elementos="elementos" :ippm="parseFloat(form.acvi_ippm)" :ippo="parseFloat(ippm_MesAnterior)"
            @update:datos="handleElementos" />
        </el-row>
        <el-row>
          <el-form>
            <el-col>
              <el-form-item>
                <el-button type="primary" @click="submitForm('form-acta-valor-infra')">Grabar</el-button>
                <el-button @click="resetForm('form')">Restablecer</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { saveValorInfraestructura, getActaInfoAdicionalByFecha, getAllElements } from '@/api/actas'
import AddElements from './AddElements.vue'
export default {
  components: {
    AddElements
  },
  data() {
    return {
      form: {
        acvi_faom: 0.103,
        acvi_faoms: 0,
        acvi_idd: null,
        acvi_tarifa: null,
        acvi_cargaindisponib: null,
        acvi_horassinserv: null,
        eluc_id: null,
        acvi_ippm: null
      },
      elementos: [],
      acco_fechacorte: '',
      ippm_MesAnterior: null,
      rules: {
        acvi_idd: [
          {
            required: true,
            message: 'Por favor ingresa un valor para ID',
            trigger: 'blur'
          }
        ],
        acvi_tarifa: [
          {
            required: true,
            message: 'Por favor ingresa un valor para Tarifa',
            trigger: 'blur'
          }
        ],
        acvi_cargaindisponib: [
          {
            required: true,
            message: 'Por favor ingresa un valor para carga por indisponible',
            trigger: 'blur'
          }
        ],
        acvi_horassinserv: [
          {
            required: true,
            message: 'Por favor ingresa un valor para horas sin servicio',
            trigger: 'blur'
          }
        ],
        acvi_ippm: [
          {
            required: true,
            message: 'Por favor ingresa el valor del ipp del Dane para el mes seleccionado',
            trigger: 'blur'
          }
        ]
      }
    }

  },

  mounted() {
    const savedElements = localStorage.getItem("acta_form_data");
    if (savedElements) {
      const data = JSON.parse(savedElements);
      this.elementos = this.sortElements(data.elementos);
    } else {
      getAllElements().then((response) => {
        this.elementos = this.sortElements(response.data);
        this.setDefaultValues();
      });
    }
  },
  methods: {
    async fetchIPPByFechaCorte() {
      if (!this.acco_fechacorte) return;

      try {
        const fechaCompleta = `${this.acco_fechacorte}-01`
        const fecha = new Date(fechaCompleta  + "T00:00:00");
        fecha.setMonth(fecha.getMonth() - 1);
        const anio = fecha.getFullYear();
        let mes = fecha.getMonth() + 1;
        mes = mes < 10 ? `0${mes}` : mes;
        const fechaAnterior = `${anio}-${mes}-01`;
        console.log(fechaAnterior);
        const response = await getActaInfoAdicionalByFecha(fechaAnterior);

        if (response.data && response.data.acco_infoadicional) {
          const infoAdicional = response.data.acco_infoadicional;

          this.ippm_MesAnterior = infoAdicional.acvi_ippm || null;
        } else {
          this.$message({
            message: 'No se encontraron datos para la fecha de corte seleccionada.',
            type: 'warning'
          });
        }
      } catch (error) {
        console.error('Error al obtener IPP:', error);
        this.$message({
          message: 'Error al obtener el IPP',
          type: 'error'
        });
      }
    },
    saveToLocalStorage() {
      const dataToSave = {
        form: this.form,
        elementos: this.elementos,
        acco_fechacorte: this.acco_fechacorte
      }
      localStorage.setItem('acta_form_data', JSON.stringify(dataToSave))
    },
    sortElements(data) {
      return data
        .map((type) => {
          const validos = type.elements.filter(el => el.acvi_cantidad > 0);

          const ordenados = validos.sort((a, b) => {
            if (a.elemento < b.elemento) return -1;
            if (a.elemento > b.elemento) return 1;
            return a.acvi_potencia - b.acvi_potencia;
          });

          return {
            ...type,
            elements: ordenados,
          };
        })
        .filter(type => type.elements.length > 0);
    },
    handleElementos(elementos) {
      this.elementos = elementos
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.form.acvi_faom = 0.103;
          this.form.acvi_faoms = 0;
          let data = {}
          this.elementos.forEach(element => {
            data[element.eluc_nombre] = []
            data[element.eluc_nombre] = element.elements
          })
          const datos = {
            cto_max_aom: {
              acvi_faom: parseFloat(this.form.acvi_faom),
              acvi_faoms: parseFloat(this.form.acvi_faoms),
              acvi_idd: parseFloat(this.form.acvi_idd),
              acvi_tarifa: parseFloat(this.form.acvi_tarifa),
              acvi_ippm: parseFloat(this.form.acvi_ippm),
              acvi_ippo: parseFloat(this.ippm_MesAnterior),
              acvi_cargaindisponib: parseFloat(
                this.form.acvi_cargaindisponib
              ),
              acvi_horassinserv: parseFloat(this.form.acvi_horassinserv)
            },
            datos: data,
            acco_fechacorte: `${this.acco_fechacorte}-01`,
            usua_id: this.usuario.usua_id,
            empr_id: this.empresa.empr_id
          }
          saveValorInfraestructura(datos)
            .then(response => {
              if (response.data.created) {
                this.$message({
                  message: 'Acta grabada con éxito',
                  type: 'success'
                })
                localStorage.removeItem('acta_form_data')
                getAllElements().then((response) => {
                  // Actualiza los elementos con los datos ordenados desde la API
                  this.elementos = this.sortElements(response.data);

                  // Reinicia el formulario
                  this.resetForm('form-acta-valor-infra');
                });
              } else {
                this.$message({
                  message: 'Error al grabar el acta',
                  type: 'error'
                })
              }
            })
            .catch(err => {
              console.error(err)
              this.$message({
                message: 'Error al grabar el acta',
                type: 'error'
              })
            })
        } else {
          console.log('error en el formulario')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    setDefaultValues() {
      this.elementos.forEach(type => {
        type.elements.forEach(element => {
          element.acvi_expansion = 0;
          element.acvi_retiro = 0;
          element.acvi_cantidad = element.acvi_cantidad_final;
        });
      });
    },
    checkFormCompletion() {
      const { acvi_ippm } = this.form;
      return acvi_ippm;
    },
    
    forceUpdateElementos() {
      // Esto reemitirá el arreglo para que el hijo reprocese los datos
      this.elementos = [...this.elementos];
    },

  },
  computed: {
    ...mapGetters(['empresa', 'usuario'])
  },
  watch: {
    form: {
      handler(val) {
        this.saveToLocalStorage();

        // Cuando se completen todos los campos, actualiza el hijo
        if (this.checkFormCompletion()) {
          this.forceUpdateElementos();
        }
      },
      deep: true
    },
    elementos: {
      handler(val) {
        this.saveToLocalStorage()
      },
      deep: true
    },
    acco_fechacorte(val) {
      this.saveToLocalStorage();
      this.fetchIPPByFechaCorte();
    },
    
  }
}
</script>

<style scoped></style>
